import { ENV } from "../../config/runtimeEnv";
import { Customer, CustomerContactUpdate } from "../../types/inventory/CustomerTypes";
import type { UserUuid } from "../../types/identity";
import { http } from "../../lib/http/client";
const API_BASE_URL = ENV.VITE_COMMERCE_SERVER;


/** CU-86d44j2ac — isActive is optional end to end; omitting it keeps the previous unfiltered listing. */
export const fetchCustomers = async (
	page = 1,
	perPage = 30,
	search = "",
	isActive?: boolean,
): Promise<{ data: Customer[]; total: number }> => {
	const response = await http.post(
		`${API_BASE_URL}/customers`,
		{
			page,
			per_page: perPage,
			...(search.trim() ? { search: search.trim() } : {}),
			...(isActive === undefined ? {} : { is_active: isActive }),
		},
	);

	return {
		data: response.data.data ?? [],
		total: response.data.pagination?.total_items ?? 0,
	};
};

export const updateCustomerContact = async (
	id: UserUuid,
	update: CustomerContactUpdate,
): Promise<Customer> => {
	const response = await http.put(
		`${API_BASE_URL}/customers/${id}`,
		update,
	);

	return response.data.data;
};

/** CU-86d45b2v8 — the bounded capability writer: one boolean to the dedicated Commerce route, nothing else. */
export const updateCustomerAdvanced = async (
	id: UserUuid,
	customerAdvanced: boolean,
): Promise<Customer> => {
	const response = await http.put(
		`${API_BASE_URL}/customers/${id}/advanced`,
		{ customer_advanced: customerAdvanced },
	);

	return response.data.data;
};
